import { getCachedTheme, applyThemeToDom } from './utils/themeCache';

// Apply the cached theme synchronously, before React mounts, so the UI paints
// with the correct theme (background, dark class, and CSS variables) on the
// very first frame instead of flashing from the default light theme to the
// user's actual theme. The cache is a synchronous localStorage mirror kept in
// sync by SettingsContext; chrome.storage.local is async and cannot be read
// before first paint.
applyThemeToDom(getCachedTheme() || 'light');
